import { InteriorComponent, ProductInfoComponent, ProductType, OrganizerComponent } from '@inter-ikea-storageone/range';
import { PlannerConflictResolver } from '@inter-ikea-storageone/range';
import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
export class SmastadConflictResolver extends PlannerConflictResolver {
    createConflict({ targetEntity, collidingEntity, entitiesToAddToCollidingEntityProductIds, collidingEntityAssembly }) {
        // Conflict detection logic specific to Smastad range
        if (targetEntity.hasComponent(InteriorComponent.id) ||
            targetEntity.hasComponent(OrganizerComponent.id)) {
            if (collidingEntity.getComponent(ProductInfoComponent.id)?.productType ===
                ProductType.SMASTAD_DOOR_FRONT ||
                collidingEntity.getComponent(ProductInfoComponent.id)?.productType ===
                    ProductType.SMASTAD_DRAWER_ASM ||
                collidingEntity.getComponent(ProductInfoComponent.id)?.productType ===
                    ProductType.SMASTAD_FRONT_LAYOUT ||
                collidingEntity.getComponent(ProductInfoComponent.id)?.productType ===
                    ProductType.SMASTAD_HINGE_DOOR_ASM) {
                const parent = HierarchyUtils.findWithComponentInUpwardsHierarchy(targetEntity, ComponentIds.FRAME_COMPONENT_ID);
                if (!parent)
                    return null;
                const addAction = this.addEntityToTargetAction({
                    entity: collidingEntityAssembly ? collidingEntityAssembly : collidingEntity,
                    parentEntityId: parent.id,
                    entitiesToAddToCollidingEntityProductIds
                });
                return {
                    entityId: targetEntity.id,
                    solve: [this.deleteAction(targetEntity.id), addAction],
                    messages: {
                        title: 'storageone.warningDoorHingeCollideWithInteriorsTitle',
                        info: 'storageone.collisionSheetInfoText',
                        yesButton: 'storageone.collisionSheetButtonAddLayout',
                        noButton: 'storageone.collisionSheetButtonDontAddLayout'
                    }
                };
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    }
}
//# sourceMappingURL=smastadConflictResolver.js.map